export class GetIntegrationsDetails {
  static readonly type = '[Integrations] Get Integrations Details';
}
